module.exports = __webpack_public_path__ + "static/img/claw-toggle.b9633a86.svg";